import type { Workspace } from '@/types/workspace';

/**
 * BOXY-352 — two workspaces with the same name looked identical everywhere.
 * For every workspace whose name collides with another in the list, a short
 * tag from its uid ("#7BZ7D"); unique names get none, so they look as before.
 */
export function duplicateNameTags(
  workspaces: Pick<Workspace, 'uid' | 'name'>[],
): Record<string, string> {
  const key = (name: string | null) => (name ?? '').trim().toLowerCase();
  const counts = new Map<string, number>();
  workspaces.forEach((w) => counts.set(key(w.name), (counts.get(key(w.name)) ?? 0) + 1));

  return Object.fromEntries(
    workspaces
      .filter((w) => (counts.get(key(w.name)) ?? 0) > 1)
      .map((w) => [w.uid, `#${w.uid.slice(-5).toUpperCase()}`]),
  );
}
